import { Stack, Typography } from '@mui/material';
import { FC } from 'react';
import './PeakEnergyCard.scss';
import { East, NorthEast, SouthEast } from '@mui/icons-material';
import { EnergyValueCardProps } from '../../../types';
import { useTranslation } from 'react-i18next';

const PeakEnergyCard: FC<EnergyValueCardProps> = ({
  peakEnergy,
  dataTrendPeriod,
  diff,
  diffColor,
}) => {
  const { t } = useTranslation();
  return (
    <Stack direction="row" alignItems="end" gap={3} px={1}>
      <Stack flex={1}>
        <Typography variant="h2" className="energy-value-card__energy-value">
          {Math.round(peakEnergy)}
        </Typography>
        <Typography variant="body2" className="energy-value-card__energy-unit">
          {dataTrendPeriod === 'daily'
            ? t('data.circadian.peakEnergy')
            : t('data.circadian.avgPeakEnergy')}
        </Typography>
      </Stack>
      {typeof diff === 'number' && diff !== null && (
        <Stack flex={1} alignItems="flex-start">
          <Typography className="energy-value-card__diff" variant="body1" sx={{ color: diffColor }}>
            {diff > 0 ? (
              <>
                <NorthEast className="energy-value-card__diff__icon" /> {Math.abs(diff)}
              </>
            ) : diff < 0 ? (
              <>
                <SouthEast className="energy-value-card__diff__icon" /> {Math.abs(diff)}
              </>
            ) : diff === 0 ? (
              <>- {Math.abs(diff)}</>
            ) : (
              ''
            )}
          </Typography>
          <Typography className="energy-value-card__diff-label" variant="body2">
            {dataTrendPeriod === 'daily'
              ? t('data.common.vsPrevDay')
              : t('data.common.vsPrevWeek')}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};

export default PeakEnergyCard;
